import { useMemo, memo } from 'react';
import { DayPicker } from 'react-day-picker';
import {
  DEFAULT_MIN_DATE, getPreviousMonth, setEndOfDay, setStartOfDay,
} from '../../../../services/dateTimeFormatter';
import { IDateRangePickerProps } from '../../index';

const DefaultDateRangePicker = (props: IDateRangePickerProps) => {
  const {
    onRangeSelect, selectedRange, minDate = DEFAULT_MIN_DATE, maxDate,
  } = props;
  const defaultMonth = useMemo(() => getPreviousMonth(selectedRange?.from), [selectedRange?.from]);
  const fromDate = useMemo(() => setStartOfDay(minDate), [minDate]);
  const toDate = useMemo(() => setEndOfDay(maxDate ?? new Date()), [maxDate]);

  return (
    <DayPicker
      mode="range"
      selected={selectedRange}
      onSelect={onRangeSelect}
      numberOfMonths={2}
      defaultMonth={defaultMonth}
      fromDate={fromDate}
      toDate={toDate}
    />
  );
};

export default memo(DefaultDateRangePicker);
